// extracted by mini-css-extract-plugin
export default {"default":"Panel-module__default__XgSTh","blue":"Panel-module__blue__qp+6j","border":"Panel-module__border__bEMKu","dashboardtable":"Panel-module__dashboardtable__2MTKq"};